"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Students = function Students(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "StudentsTitle StudentsDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "StudentsTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "StudentsDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M26.511 11.716a4 4 0 0 1 3.996 3.995v8.667H19.582v-1.111h9.814V15.71a2.889 2.889 0 0 0-2.885-2.884h-8.138c-1.215 0-2.3.76-2.715 1.902l-1.045-.378a4 4 0 0 1 3.76-2.635h8.138zm-13.382 8.27a1.267 1.267 0 1 1 0 2.534 1.267 1.267 0 0 1 0-2.533zm-3.28-6.097a3.84 3.84 0 1 0 0-7.68 3.84 3.84 0 0 0 0 7.68zm0-6.565a2.729 2.729 0 1 1 0 5.458 2.729 2.729 0 0 1 0-5.458zm4.067 8.885H5.778a4 4 0 0 0-4 4v8.667H17.91v-8.672a4 4 0 0 0-3.995-3.995zm2.888 11.555H2.894V20.21a2.889 2.889 0 0 1 2.884-2.889h8.138a2.889 2.889 0 0 1 2.888 2.884v7.56zm5.192-18.333a3.84 3.84 0 1 0 0-7.68 3.84 3.84 0 0 0 0 7.68zm0-6.564a2.729 2.729 0 1 1 0 5.457 2.729 2.729 0 0 1 0-5.457z",
    id: "refStudentsVKi100jChF5"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#refStudentsVKi100jChF5"
  }));
};

Students.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Students.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Students;
exports["default"] = _default;